<template>
	<div class="staff_head">
		<div class="staff_l">
			<img src="../assets/structure/close.png" class="staff_close" @click="close" />
			<div>{{ title }}</div>
		</div>
		<div style="text-align: right;">
			<el-button @click="close">取消</el-button>
			<el-button type="primary" v-if="isAdd" :loading="subLoading" @click="confirm">确认</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			isAdd: true,
			subLoading: false,
			title: ''
		},
		data() {
			return {

			}
		},
		methods: {
			close() {
				this.$emit("close");
			},
			confirm() {
				this.$emit("confirm");
			}
		}
	}
</script>

<style>
	.staff_head {
		height: 90px;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 99;
		background: white;
		padding: 0 30px 0 20px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid #cfd4e8;
	}

	.staff_close {
		cursor: pointer;
		width: 24px;
		height: 24px;
		margin-right: 20px;
	}

	.staff_l {
		display: flex;
		align-items: center;
		font-size: 18px;
		color: #1a1a1a;
	}
</style>